module.exports = __webpack_public_path__ + "static/media/g10-transportes.a62c9f7b.svg";